import React, { useState, Fragment } from 'react';
import { MenuIcon, XIcon, ShoppingBag } from 'lucide-react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
export function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const menuItems = ['Impacto', 'Alianzas'];
  const scrollToSection = (sectionId: string) => {
    const id = sectionId.toLowerCase();
    setMobileMenuOpen(false);
    if (location.pathname !== '/') {
      navigate('/');
      // wait for home to render before scrolling
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({
          behavior: 'smooth'
        });
      }, 100);
      return;
    }
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <>
      <nav className="mp-navbar sticky top-0 left-0 right-0 z-50 flex items-center" style={{
      minHeight: '85px',
      background: '#ffffff',
      boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
      paddingLeft: '32px',
      paddingRight: '32px'
    }} data-id="element-132" data-mp="1pwzxupbnb98y">
        <div className="max-w-7xl mx-auto w-full" data-id="element-133" data-mp="elptgwzg8dgm">
          <div className="flex justify-between items-center" data-id="element-134" data-mp="jm44mnwck3iv">
            <div className="flex-shrink-0" data-id="element-135" data-mp="jkkp4ziilwi5">
              <Link to="/" data-id="element-136" data-mp="om09epcvbyzh">
                <img src="https://cdn.magicpatterns.com/uploads/5M6X1iYfRiLeS5bu5erw4R/3.png" alt="Pancita Feliz Foundation" className="mp-navbar-logo object-contain block" style={{
                width: '160px',
                height: 'auto',
                minWidth: '160px',
                marginRight: '32px',
                objectFit: 'contain'
              }} data-id="element-137" data-mp="ol8bv8zpnr6k" />
              </Link>
            </div>

            <div className="hidden md:flex items-center space-x-6" data-id="element-138" data-mp="34b1voc9p2vvu">
              <Link to="/venezuela-emergencia" className="mp-nav-emg-link" style={{
              color: '#CC0000',
              fontWeight: 600,
              fontSize: '11px',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              padding: '4px 8px',
              borderRadius: '14px',
              border: '1.5px solid #CC0000',
              whiteSpace: 'nowrap',
              textDecoration: 'none',
              transition: 'all 0.2s'
            }} data-id="element-139" data-mp="39aehctotxwwu">
                <div style={{
                width: '8px',
                height: '8px',
                background: '#CC0000',
                borderRadius: '50%',
                animation: 'navPulse 1.5s infinite'
              }} data-id="element-140" data-mp="2dfoyghv7gzzc" />
                SOS Venezuela
              </Link>
              {menuItems.map(item => <Fragment key={item} data-id="element-141" data-mp="2ndod772cej4">
                  <button onClick={() => scrollToSection(item)} className="text-sm text-dark hover:text-primary transition-colors font-medium" data-id="element-142" data-mp="a4950y8d3d3s">
                    {item}
                  </button>
                  {item === 'Alianzas' && <Link to="/quiero-ser-aliado" className="text-sm text-dark hover:text-primary transition-colors font-medium" data-id="element-143" data-mp="55633mnohn01">
                      Ser Aliado
                    </Link>}
                </Fragment>)}
              <Link to="/tienda" style={{
              color: '#2d5a1b',
              fontWeight: 600,
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              textDecoration: 'none',
              whiteSpace: 'nowrap'
            }} data-id="element-144" data-mp="k1x420d036rr">
                <ShoppingBag size={14} data-id="element-145" data-mp="3p2qbrjf6obh8" />
                Tienda
              </Link>
              <Link to="/solicitar-ayuda" className="text-sm transition-colors hover:text-primary" style={{
              color: '#1a1a1a',
              fontWeight: 600,
              background: 'transparent',
              border: 'none',
              padding: '8px 12px',
              textDecoration: 'none',
              whiteSpace: 'nowrap'
            }} data-id="element-146" data-mp="3k2kpyjvlhj72">
                Solicitar Ayuda
              </Link>
              <Link to="/donar" className="bg-primary text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-primary/90 transition-colors" data-id="element-147" data-mp="1vwod3zr7e65">
                Donar Ahora
              </Link>
            </div>

            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden p-2 rounded-lg hover:bg-gray-100" aria-label="Toggle menu" data-id="element-148" data-mp="pmtm9cupsaye">
              {mobileMenuOpen ? <XIcon className="h-6 w-6 text-dark" data-id="element-149" data-mp="2d9fwd6dfn0zn" /> : <MenuIcon className="h-6 w-6 text-dark" data-id="element-150" data-mp="2h9qbb8j7d1qn" />}
            </button>
          </div>
        </div>

        {mobileMenuOpen && <div className="md:hidden bg-white border-t absolute top-full left-0 right-0" data-id="element-151" data-mp="2m78c2bn2gank">
            <div className="px-4 py-4 space-y-3" data-id="element-152" data-mp="2r85verjtbaqn">
              <Link to="/venezuela-emergencia" onClick={() => setMobileMenuOpen(false)} style={{
            color: '#CC0000',
            fontWeight: 700,
            padding: '12px 16px',
            borderBottom: '1px solid #eee',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '15px',
            textDecoration: 'none'
          }} data-id="element-153" data-mp="2w6z6kdbmmpnn">
                <div style={{
              width: '8px',
              height: '8px',
              background: '#CC0000',
              borderRadius: '50%',
              animation: 'navPulse 1.5s infinite'
            }} data-id="element-154" data-mp="1ewiqqnfhyee0" />
                SOS Venezuela
              </Link>
              {menuItems.map(item => <Fragment key={item} data-id="element-155" data-mp="1xl79b2qic7mm">
                  <button onClick={() => scrollToSection(item)} className="block w-full text-left px-4 py-2 text-dark hover:bg-gray-50 rounded-lg font-medium" data-id="element-156" data-mp="1xoblama7s7nu">
                    {item}
                  </button>
                  {item === 'Alianzas' && <Link to="/quiero-ser-aliado" onClick={() => setMobileMenuOpen(false)} className="block w-full text-left px-4 py-2 text-dark hover:bg-gray-50 rounded-lg font-medium" data-id="element-157" data-mp="d6do765ltha6">
                      Ser Aliado
                    </Link>}
                </Fragment>)}
              <Link to="/tienda" onClick={() => setMobileMenuOpen(false)} style={{
            color: '#2d5a1b',
            fontWeight: 600,
            fontSize: '15px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '12px 16px',
            textDecoration: 'none'
          }} data-id="element-158" data-mp="2ovlbj23shf3b">
                <ShoppingBag size={16} data-id="element-159" data-mp="1r7ji42t3fahl" />
                Tienda
              </Link>
              <Link to="/solicitar-ayuda" onClick={() => setMobileMenuOpen(false)} className="block w-full text-left px-4 py-2 hover:bg-gray-50 rounded-lg" style={{
            color: '#1a1a1a',
            fontWeight: 600,
            background: 'transparent',
            border: 'none',
            textDecoration: 'none'
          }} data-id="element-160" data-mp="1w64ic28chu61">
                Solicitar Ayuda
              </Link>
              <Link to="/donar" onClick={() => setMobileMenuOpen(false)} className="block w-full text-center bg-primary text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-primary/90 transition-colors" data-id="element-161" data-mp="24imq0no31jlk">
                Donar Ahora
              </Link>
            </div>
          </div>}
      </nav>
    </>;
}